import type { ReactNode } from 'react'

interface AtlasPageProps {
  narrow?: boolean
  children: ReactNode
  className?: string
}

export function AtlasPage({ narrow, children, className = '' }: AtlasPageProps) {
  return (
    <div className={`bg-paper shadow-page mx-auto mt-lg p-[0.5rem] ${narrow ? 'max-w-[32rem]' : 'max-w-[72rem]'} ${className}`}>
      <div className="border-3 border-double border-frame p-lg">
        {children}
      </div>
    </div>
  )
}
